import modalStyle from "../../modal.module.scss";

import icn_btn_rediscover from "assets/images/icons/icn_btn_rediscover.svg";
import icn_ap from "assets/images/icons/icn_dashboard_ap.svg";
import icn_ap_online from "assets/images/icons/icn_dashboard_ap_off.svg";
import icn_switch from "assets/images/icons/icn_dashboard_switch_off.svg";
import icn_switch_offline from "assets/images/icons/icn_dashboard_switch.svg";
import icon_snmp from "assets/images/icons/icn_Info_solid.svg";
import icon_snmp_hover from "assets/images/icons/icn_info_solid_hover.svg";

import React, { useState, useEffect } from 'react';
import { TableHead, TableRow, TableCell, TableContainer, Table, Box, Tooltip } from "@mui/material";
import { cloneDeep } from "lodash";

import { deviceTypeOption, defaultAdoptionColumns, protocolTypeOption } from "../../../const";
import { getDefaultTableProp, } from "../../../theme";

const DeviceTable = (props) => {
  const { currentStep, totalSteps, devices, results } = props;

  // State
  const [columns, setColumns] = useState(cloneDeep(defaultAdoptionColumns));

  // Method
  const displaySshTooltip = (device) => {
    return device.protocolType === protocolTypeOption.snmp ? (
      <Tooltip
        arrow
        title={
          <Box>
            Please enable SSH on this switch before adoption.
          </Box>
        }>
        <Box
          display="flex"
          alignItems="center" sx={{
            ml: "10px",
            "& img": {
              content: `url(${icon_snmp})`, // default
            },
            "&:hover img": {
              content: `url(${icon_snmp_hover})`, // hover
            },
          }}
        >
          <img src={icon_snmp} alt="" />
        </Box>
      </Tooltip>
    ) : null;
  }

  const getModelName = (device) => {
    if (device.deviceType.value === deviceTypeOption.ap.value) {
      return (
        <Box display="flex" alignItems="center">
          <Box display={'flex'} alignItems='center'>
            <img
              src={device.linkStatus === "online" ? icn_ap_online : icn_ap}
              alt="AP"
              style={{ width: '60px', marginRight: '8px' }}
            />
            {device.modelName}
          </Box>
          {displaySshTooltip(device)}
        </Box>
      );
    }

    if (device.deviceType.value === deviceTypeOption.switch.value) {
      return (
        <Box display="flex" alignItems="center">
          <Box display={'flex'} alignItems='center'>
            <img
              src={device.linkStatus === "online" ? icn_switch : icn_switch_offline}
              alt="Switch"
              style={{ width: '60px', marginRight: '8px' }}
            />
            {device.modelName}
          </Box>
          {displaySshTooltip(device)}
        </Box>
      );
    }
  }

  const getResult = (device) => {
    const result = results.find((res) => res.macAddress === device.macAddress);

    if (result === undefined) {
      return (
        <>
          <img
            src={icn_btn_rediscover}
            alt="discovery"
            style={{ width: '20px', height: '20px', marginRight: '5px' }}
          />
        </>
      );
    }

    if (result.hasOwnProperty('isAdopted')) {
      if (result.isAdopted) {
        return (
          <span style={{ color: "#00FF00", fontWeight: 'bold' }}>
            Success
          </span>
        );
      } else {
        return (
          <span style={{ color: "#FF0000", fontWeight: 'bold' }}>
            Failed
          </span>
        );
      }
    }

    if (result.hasOwnProperty('isIpSetting')) {
      if (result.isIpSetting) {
        return (
          <span style={{ color: "#00FF00", fontWeight: 'bold' }}>
            Success
          </span>
        );
      } else {
        return (
          <span style={{ color: "#FF0000", fontWeight: 'bold' }}>
            Failed
          </span>
        );
      }
    }

    if (result.hasOwnProperty('isAuthenticated')) {
      if (result.isAuthenticated) {
        return (
          <span style={{ color: "#00FF00", fontWeight: 'bold' }}>
            Success
          </span>
        );
      } else {
        return (
          <span style={{ color: "#FF0000", fontWeight: 'bold' }}>
            Failed
          </span>
        );
      }
    }
  }

  const renderTableHead = () => (
    <TableHead
      sx={{ ...getDefaultTableProp().tableHead.sx }}
    >
      <TableRow sx={{ ...getDefaultTableProp().tableHead.tableRow.sx }}>
        {columns
          .filter((col) => col.visible)
          .map((col) =>
            <TableCell
              key={`${col.id}-head-cell`}
              sx={{ ...getDefaultTableProp().tableHead.tableCell.text }}
            >
              {col.label}
            </TableCell>
          )}
      </TableRow>
    </TableHead >
  );

  const renderTableBody = () => (
    <tbody>
      {devices.map((device, rowIndex) => (
        <TableRow
          key={`${device.macAddress}-row`}
          sx={{ ...getDefaultTableProp(rowIndex).tableBody.tableRow }}
        >
          {columns
            .filter((col) => col.visible)
            .map((col) =>
              <TableCell
                key={`${device.macAddress}-${col.id}-cell`}
                sx={{ ...getDefaultTableProp().tableBody.tableCell.text }}
              >
                {
                  col.id === "result" ? (
                    <>{getResult(device)}</>
                  ) : col.id === "modelName" ? (
                    <>{getModelName(device)}</>
                  ) : col.id === "macAddress" ? (
                    device.macAddress
                  ) : col.id === "ipAddress" ? (
                    device.ipAddress
                  ) : null
                }
              </TableCell>
            )}
        </TableRow>
      ))}
    </tbody>
  );

  // Side effect
  useEffect(() => {
    if (currentStep === totalSteps) {
      const updatedColumns = cloneDeep(columns);
      updatedColumns.forEach((col) => {
        if (col.id === "result") {
          col.visible = true;
        }
      });
      setColumns(updatedColumns);
    }
  }, [currentStep]);

  return (
    <>
      <div className={modalStyle['modal_Block']} style={{ margin: '20px 0', maxHeight: '400px' }}>
        <TableContainer style={{ overflowY: 'auto' }} >
          <Table>
            {renderTableHead()}
            {renderTableBody()}
          </Table>
        </TableContainer>
      </div >
    </>
  );
}

export default DeviceTable;